import axios from 'axios';
import { 
    price_endpoint , 
    email_verification_code_send_endpoint,
    email_verification_code_verify_endpoint,
    registration_endpoint
} from "../../libs/endpoints";


export const load_price_data_action = async () => {
    const response = await axios.get(`${price_endpoint}`);
    return response
}


export const email_verification_code_send_action = async (email) => {
    console.log('email_verification_code_send_action')
    const response = await axios.post(`${email_verification_code_send_endpoint}`, {
        'email':  email
    });
    return response
}


export const email_verification_code_verify_action = async (email, verification_code) => {
    console.log('email_verification_code_verify_action')

    const data = {
       'email' : email,
       'verification_code' : verification_code
    }

    const response = await axios.post(email_verification_code_verify_endpoint, data);
    return response
}



export const submit_registration_action = async ({first_name, last_name, email , domain, company_name , price_id}) => {
    console.log('submit_registration_action')
    const data = {
       'first_name' : first_name,
       'last_name' :  last_name,
       'email' :  email,
       'domain' : domain,
       'company_name' : company_name,
       'price_id' : price_id
    }
    console.log(data)
    const response = await axios.post(`${registration_endpoint}`, data);
    return response
}
